import { HtmlParser } from '@calendly/html-parser';
import { I18n } from '@calendly/i18n';
import { Banner } from '@calendly/ui/components/banner';
import { MegaphoneIcon } from '@calendly/ui/components/icons';
import { Link as ExternalLink } from '@calendly/ui/components/link';
import classNames from 'classnames';
import { useState, forwardRef } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { useGetUserQuery } from 'common';
import { paymentMethodSelector, paidStageSelector } from 'features/billing/selectors';
import { billingAddressCountrySelector } from 'features/billing/stages/paid_stage/billing_information_card/selectors';
import { useTrack } from 'hooks/analytics_events/useTrack';
import { ctaClickedEvent, trackBannerShown } from './analytics';
const styledLinkCss = "s1hcwlxu";
const StyledLink = forwardRef((props, ref) => <Link ref={ref} {...props} className={classNames(styledLinkCss, props.className)} />);
const styledExternalLinkCss = "su149i8";
const StyledExternalLink = forwardRef((props, ref) => <ExternalLink ref={ref} {...props} className={classNames(styledExternalLinkCss, props.className)} />);
const BillingPageLink = ({
  children
}) => {
  const track = useTrack();
  const onClick = () => ctaClickedEvent(track, 'vat_banner_billing_page');
  const isBillingPage = window.location.pathname.startsWith('/app/admin/billing');
  if (isBillingPage) {
    return <StyledExternalLink href="/app/admin/billing#billing-information" onClick={onClick}>
        {children}
      </StyledExternalLink>;
  }
  return <StyledLink to="/app/admin/billing" onClick={onClick}>
      {children}
    </StyledLink>;
};
const HelpCenterLink = ({
  children
}) => {
  const track = useTrack();
  const onClick = () => ctaClickedEvent(track, 'vat_banner_helpcenter_article');
  return <StyledExternalLink href="https://help.calendly.com/hc/en-us/articles/360048510434-Sales-tax-and-your-Calendly-subscription" target="_blank" rel="opener" onClick={onClick}>
      {children}
    </StyledExternalLink>;
};
const BillingEmailLink = () => {
  const track = useTrack();
  const onClick = () => ctaClickedEvent(track, 'vat_banner_billing_mailto');
  return <StyledExternalLink href="mailto:billing@calendly.com" onClick={onClick}>
      billing@calendly.com
    </StyledExternalLink>;
};
const SpacedMegaphoneIcon = () => <MegaphoneIcon spacingRight={4} />;
export const VatNoticeBanner = () => {
  const vatCountries = ['AT', 'AU', 'BE', 'BG', 'CA', 'CY', 'CZ', 'DE', 'DK', 'EE', 'ES', 'FI', 'FR', 'GB', 'GR', 'HR', 'HU', 'IE', 'IN', 'IT', 'LT', 'LU', 'LV', 'MT', 'NL', 'PL', 'PT', 'RO', 'SE', 'SI', 'SK'];
  const localStorage = window.localStorage;
  const [hideBanner, setHideBanner] = useState(localStorage.getItem('vat_notice_banner_dismissed'));
  const {
    data: {
      organization_membership: {
        role: userRole
      }
    }
  } = useGetUserQuery();
  const paymentMethod = useSelector(paymentMethodSelector);
  const billingCountry = useSelector(billingAddressCountrySelector);
  const isPaidStage = useSelector(paidStageSelector);
  const track = useTrack();
  const isOwnerOfPaidOrg = userRole === 'owner' && isPaidStage;
  const isVatCountry = vatCountries.includes(billingCountry) || !billingCountry && paymentMethod === 'paypal';
  if (hideBanner || !isOwnerOfPaidOrg || !isVatCountry) return null;
  const onClose = () => {
    localStorage.setItem('vat_notice_banner_dismissed', 'true');
    setHideBanner(true);
    ctaClickedEvent(track, 'vat_banner_closed');
  };
  trackBannerShown(track);
  return <Banner icon={SpacedMegaphoneIcon} spacingBottom={8} onClose={onClose}>
      {HtmlParser(I18n.t('publisher.billing.vat_notice_banner.body'), {
      BillingPageLink,
      BillingEmailLink,
      HelpCenterLink
    })}
    </Banner>;
};

require("./vat_notice_banner.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./vat_notice_banner.js");